var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3949_2108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10299 6.0902C7.77545 6.0902 9.13127 4.80577 9.13127 3.22137C9.13127 1.63697 7.77545 0.352539 6.10299 0.352539C4.43053 0.352539 3.07409 1.63697 3.07409 3.22137C3.07409 4.80577 4.43053 6.0902 6.10299 6.0902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38762 6.28574H4.81789C2.68006 6.28574 0.940678 7.93355 0.940678 9.9594V12.9362L0.948733 12.9826L1.16499 13.0466C3.20553 13.6507 4.97776 13.852 6.43706 13.852C9.28687 13.852 10.9383 13.0824 11.0405 13.0331L11.2425 12.9362H11.2642V9.95881C11.2648 7.93355 9.52544 6.28516 7.38762 6.28516V6.28574Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3949_2108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.3235,
    height: 13.5,
    fill: "white",
    transform: "translate(0.940678 0.352539)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.501534fe6a276869284d0e2994942e29.svg";
export { ForwardRef as ReactComponent };